import { Card, Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
    callAPI,
    clearRequest,
    getLocalValue,
    handleApiError,
    IsSmallScreen,
    LoacalVariables,
    Method,
    updateMainHeader
} from "../../commonFunctions/CommonFunctions";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import WSDateField from "../../Components/DateField/WSDateField";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, {
    CurrencyType,
    TextType
} from "../../Components/TextBox/WSTextBox";
import { WSView } from "../../Components/View/WSView";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import config from "../../Config/clientConfig.json";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const Invoice: React.FC<any> = React.memo((props) => {
    const { id, invId, orderId } = useParams();
    const [loading, setLoading] = useState(false)
    const [termsAndConditions, setTermsAndConditions] = useState<any>();
    //   const paymentTermsDefault: any = [
    //     {
    //       percentage: 30,
    //       description: "of total value of work on order confirmation."
    //     },
    //     {
    //       percentage: 60,
    //       description:
    //         "of total value of work on delivery of material to site."
    //     },
    //     {
    //       percentage: 10,
    //       description: "balance after completion of work."
    //     }
    //   ]
    const { control, register, handleSubmit, setValue, watch, getValues } =
        useForm({
            defaultValues: {
                customerName: "",
                accountId: "",
                tax: "",
                address: "",
                discount: "",
                adjustments: "",
                leadId: "",
                items: [
                    { productId: "", quantity: "", unit: "", unitPrice: "", total: "", isIncluded: true, isPolish: "2" }
                ],
                itemsExcluded: [
                    { productId: "", quantity: "", unit: "", unitPrice: "", total: "", isIncluded: false }
                ],
                // paymentTerms: [
                //   {
                //     percentage: 30,
                //     description: "of total value of work on order confirmation."
                //   },
                //   {
                //     percentage: 60,
                //     description:
                //       "of total value of work on delivery of material to site."
                //   },
                //   {
                //     percentage: 10,
                //     description: "balance after completion of work."
                //   }
                // ]
            }
        });
    const { fields: itemFields, append: itemAppend, remove: itemRemove, replace: itemReplace } = useFieldArray({
        name: "items",
        control
    });
    const { fields: itemExcludedFields, append: itemExcludedAppend, remove: itemExcludedRemove, replace: itemExcludedReplace } = useFieldArray({
        name: "itemsExcluded",
        control
    });
    //   const {
    //     fields: paymentTerms,
    //     append: paymentAppend,
    //     remove: paymentRemove,
    //     replace: paymentReplace
    //   } = useFieldArray({
    //     name: "paymentTerms",
    //     control
    //   });
    const navigate = useNavigate();
    const { showMessage } = useSnackbar();
    const isMobile = IsSmallScreen()
    const [products, setProducts] = useState<any>([]);
    const [lead, setLead] = useState<any>();
    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);
    useEffect(() => {
        updateMainHeader(id ? "Edit" : 'Add');

        breadCrumbsStore.updateBreadCrumbs([
            { "Contacts": "/contacts/list" },
            { [id ? "View" : 'Add']: `/contacts/${id}/invoice` },
            { "Invoice": "" },

        ]);
    });
    //   useEffect(() => {
    //     if (!estId) {
    //       setValue('subject', `This is in references to the personal discussion the company representative had with you on regarding paving of Rubber mold paving block at your site in...
    //       `)
    //     }
    //     async function loadTerms() {
    //       try {
    //         const response: any = await callAPI("Termsandcondition", Method.GET);
    //         const terms: any = response?.data || [];

    //         const numberedString: string = terms
    //           .flatMap((item: any) => JSON.parse(item.conditions)) // parse and flatten
    //           .map((text: string, index: number) => `${index + 1}. ${text}`) // add numbering
    //           .join("\n"); // join into single string with line breaks

    //         // ✅ set the value *inside* the function
    //        setValue("termsAndConditions", numberedString);
    //         setTermsAndConditions(numberedString)
    //       } catch (err) {
    //         console.error("Failed to load terms", err);
    //       }


    //     }
    //     loadTerms()
    //   }, [])
    // useEffect(() => {
    //   if (!estId && termsAndConditions) {
    //    setValue("termsAndConditions", termsAndConditions);
    //   }
    // }, [termsAndConditions])
    useEffect(() => {
        calculateTotal(subtotal);
    }, [subtotal, watch("discount"), watch("adjustments")]);

    const calculateTotal = (newSubtotal: number) => {
        const discount = parseFloat(watch("discount")) || 0;
        const adjustments = parseFloat(watch("adjustments")) || 0;
        const newTotal = newSubtotal - discount + adjustments;
        setTotal(newTotal);
    };

    // Fetch product details on component mount
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response: any = await callAPI("products", Method.GET);
                if (response) {
                    setProducts(response.data);
                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            }
        };

        fetchProducts();
    }, []);

    useEffect(() => {
        const fetchLeads = async () => {
            try {
                const response: any = await callAPI("leads", Method.GET, null, id);
                if (response) {
                    setLead(response);
                    // setValue("ownerId", response?.ownerId);
                    setValue(
                        "customerName",
                        `${response?.firstName ?? ""} ${response?.lastName ?? ""}`.trim()
                    );

                    setValue(
                        "address",
                        [
                            response?.city,
                            response?.state,
                            response?.zipCode,
                            response?.country,
                        ]
                            .filter(Boolean)
                            .join(", ")
                    );
                    // setValue("stage", 'New');
                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            }
        };

        fetchLeads();
    }, []);

    useEffect(() => {
        const fetchEstimate = async () => {
            try {

                const response: any = await callAPI("CRMInvoice", Method.GET, {}, invId);

                if (response?.data) {
                    // Set main form values
                    //   setValue("ownerId", response.data.ownerId);
                    setValue("customerName", response.data.customerName);
                    setValue("address", response.data?.address);
                    setValue("tax", response.data?.tax);
                    setValue("accountId", response.data?.accountId);
                    setValue("discount", response.data?.discount);
                    setValue("adjustments", response.data?.adjustments);
                    //   if (response.data.termsAndConditions != "") {
                    //     setValue("termsAndConditions", response.data.termsAndConditions);
                    //   }
                    //   else{ setValue("termsAndConditions", termsAndConditions);}

                    //   setValue("remarks", response.data.remarks);
                    setValue("leadId", response.data?.leadId);

                    // Format dates
                    //   setValue("date", dayjs(response.data.date).format("MM-DD-YYYY"));
                    //   setValue(
                    //     "expiredate",
                    //     dayjs(response.data.validTill).format("MM-DD-YYYY")
                    //   );

                    setSubtotal(response.data?.subtotal);
                    setTotal(response.data?.grandTotal);

                    // Populate items
                    // if (response.data.estimateItems?.length) {
                    //   const formattedItems = response.data.estimateItems.map(
                    //     (item: any) => ({
                    //       productId: item.productId,
                    //       quantity: item.quantity.toString(),
                    //       unit: item.unit,
                    //       unitPrice: item.unitPrice.toString()
                    //     })
                    //   );

                    //   replace(formattedItems); // Updates useFieldArray fields
                    // }
                    if (response.data.quotationItems?.length) {
                        const formattedItems = response.data.quotationItems
                            .filter((item: any) => item.isIncluded === true) // ✅ keep only included items
                            .map((item: any) => ({
                                productId: item.productId,
                                quantity: item.quantity.toString(),
                                unit: item.unit,
                                unitPrice: item.unitPrice.toString(),
                                isPolish: item?.isPolish?.toString() || "2"
                            }));
                        itemReplace(formattedItems);
                        // const formattedItemsExcluded = response.data.quotationItems
                        //   .filter((item: any) => item.isIncluded === false) // ✅ keep only included items
                        //   .map((item: any) => ({
                        //     productId: item.productId,
                        //     quantity: item.quantity.toString(),
                        //     unit: item.unit,
                        //     unitPrice: item.unitPrice.toString()
                        //   }));
                        // // Updates useFieldArray fields
                        // itemExcludedReplace(formattedItemsExcluded);
                        // const formattedPaymentTerms = response.data.paymentTerms
                        //   .map((item: any) => ({
                        //     percentage: item.percentage,
                        //     description: item.description,

                        //   }));
                        // paymentReplace(formattedPaymentTerms?.length > 0 ? formattedPaymentTerms : paymentTermsDefault)
                    }

                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            }
        };

        if (invId) fetchEstimate();
    }, [invId, setValue, itemReplace]);
    useEffect(() => {

        const fetchOrderToInvoice = async () => {
            try {

                const response: any = await callAPI("workorders", Method.GET, {}, orderId);
                if (response?.data) {
                    // Set main form values
                    setValue("customerName", response.data.customerName);
                    setValue("address", response.data.address);
                    setValue("tax", response.data.tax);
                    // setValue("accountId", response.data.accountId);
                    //setValue("discount", response.data.discount);
                    //setValue("adjustments", response.data.adjustments);
                    setValue("leadId", response.data?.leadId)
                    setSubtotal(response.data?.subtotal || 0);
                    setTotal(response.data?.grandTotal || 0);

                    // Populate items
                    if (response.data.quotationItems?.length) {
                        const formattedItems = response.data.quotationItems
                            .filter((item: any) => item.isIncluded === true) // ✅ keep only included items
                            .map((item: any) => ({
                                productId: item.productId,
                                quantity: item.quantity?.toString(),
                                unit: item.unit,
                                isIncluded: true,
                                unitPrice: item.unitPrice.toString(),
                                isPolish: item?.isPolish?.toString() || "2",
                            }));

                        setTimeout(() => {
                            recalculateSubtotal()
                        }, 100);

                        // const formattedItemsExcluded = response.data.estimateItems
                        //   .filter((item: any) => item.isIncluded === false) // ✅ keep only included items
                        //   .map((item: any) => ({
                        //     productId: item.productId,
                        //     quantity: item.quantity.toString(),
                        //     unit: item.unit,
                        //     isIncluded: false,
                        //     unitPrice: item.unitPrice.toString()
                        //   }));
                        // const formattedPaymentTerms = response.data.paymentTerms
                        //   .map((item: any) => ({
                        //     percentage: item.percentage,
                        //     description: item.description,

                        //   }));
                        itemReplace(formattedItems); // Updates useFieldArray fields
                        // itemExcludedReplace(formattedItemsExcluded || []);
                        //  paymentReplace(formattedPaymentTerms)
                    }

                    // if (response.data.estimateItems?.length) {
                    //   const formattedItems = response.data.estimateItems.map(
                    //     (item: any) => ({
                    //       productId: item.productId,
                    //       quantity: item.quantity.toString(),
                    //       unit: item.unit,
                    //       unitPrice: item.unitPrice.toString()
                    //     })
                    //   );

                    //   itemReplace(formattedItems); // Updates useFieldArray fields
                    // }
                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            }
        };

        if (orderId) fetchOrderToInvoice();
    }, [orderId, setValue, itemReplace]);


    const handleData = async (data: any, isPrint = false) => {
        try {
            const items = data.items.map((i: any) => ({ ...i, isIncluded: true }));
            let productArray: any = [...items];

            const normalizedProductArray = productArray.map((item: any) => ({
                ...item,
                quantity: item.quantity ? Number(item.quantity) : undefined,
                unitPrice: item.unitPrice ? Number(item.unitPrice) : undefined,
                isPolish: (() => {
                    if (item.isPolish === '2' || item.isPolish === 2) return '2';
                    if (item.isPolish === '1' || item.isPolish === 1 || item.isPolish === true) return '1';
                    return '0';
                })(),
            }));

            let request = {
                customerName: data?.customerName || "",
                address: data?.address || "",
                accountId: data?.accountId || "",
                tax: Number(data?.tax) || 0,
                leadId: id || "",
                subtotal: Number(subtotal) || 0,
                discount: Number(data?.discount) || 0,
                adjustments: Number(data?.adjustments) || 0,
                grandTotal: Number(total) || 0,
                items: normalizedProductArray || [],
                workOrderId: orderId,
            };

            const newRequest = clearRequest(request);
            setLoading(true);

            let response: any;

            if (invId) {
                // Update existing invoice
                response = await callAPI('CRMInvoice', Method.PUT, newRequest, invId);
                console.log('response from invId', response);
            } else {
                // Create new invoice
                console.log("new request", newRequest);
                const userId = getLocalValue(LoacalVariables.UserId);
                console.log("LocalVariables.UserId is", userId);
                response = await callAPI(`CRMInvoice?UserId=${userId}`, Method.POST, newRequest);
                console.log('response from new invoice', response);
            }

            console.log('invoice id',response)
            if (response?.errors) {
                const mess = handleApiError(response);
                showMessage(mess, 'error');
            } else if (response) {
                showMessage(response?.message, response.success === true ? "success" : "error");

                if (response.success === true) {
                    const CrmInvoiceId = invId || response?.crmInvoiceId;
                    if (!isPrint) {
                        navigate(`/contacts/${id}/invoice`);
                    } else {
                        if (CrmInvoiceId) {
                            window.open(`/invoice/print/${CrmInvoiceId}`, "_blank");
                        }
                    }
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        } finally {
            setLoading(false);
        }
    };


    //   const handlePercentageChange = (
    //     index: number,
    //     event: React.ChangeEvent<HTMLInputElement>
    //   ) => {
    //     setValue(`paymentTerms.${index}.percentage`, Number(event.target.value));

    //   };
    const handleProductChange = (index: number, event: any) => {
        const selectedProductId = event.target.value; // Get selected product ID
        const selectedProduct = products.find(
            (p: any) => p.id === selectedProductId
        );
        if (selectedProduct) {
            setValue(`items.${index}.unit`, selectedProduct.unit);
            setValue(`items.${index}.unitPrice`, selectedProduct.unitPrice);

            setValue(`items.${index}.quantity`, "1"); // Convert 1 to string
            setValue(
                `items.${index}.total`,
                (selectedProduct.unitPrice * 1).toString()
            ); // Convert total to string

            // Recalculate Subtotal
            recalculateSubtotal();
        }
    };
    const handleProductChangeExcluded = (index: number, event: any) => {
        const selectedProductId = event.target.value; // Get selected product ID
        const selectedProduct = products.find(
            (p: any) => p.id === selectedProductId
        );
        if (selectedProduct) {
            setValue(`itemsExcluded.${index}.unit`, selectedProduct.unit);
            setValue(`itemsExcluded.${index}.unitPrice`, selectedProduct.unitPrice);

            setValue(`itemsExcluded.${index}.quantity`, "1"); // Convert 1 to string
            setValue(
                `itemsExcluded.${index}.total`,
                (selectedProduct.unitPrice * 1).toString()
            ); // Convert total to string

            // Recalculate Subtotal
            recalculateSubtotal();
        }
    };
    const recalculateSubtotal = () => {
        const updatedItems = getValues("items") || [];
        let newSubtotal = updatedItems.reduce((sum, item) => {
            const quantity = parseFloat(item.quantity) || 1;
            const unitPrice = parseFloat(item.unitPrice) || 0;
            return sum + quantity * unitPrice;
        }, 0);
        const updateditemsExcluded = getValues("itemsExcluded") || [];
        let newitemsExcludedSubtotal = updateditemsExcluded.reduce((sum, item) => {
            const quantity = parseFloat(item.quantity) || 1;
            const unitPrice = parseFloat(item.unitPrice) || 0;
            return sum + quantity * unitPrice;
        }, 0);
        setSubtotal(newSubtotal + newitemsExcludedSubtotal);
        calculateTotal(newSubtotal + newitemsExcludedSubtotal);
    };

    const handleQuantityChange = (
        index: number,
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setValue(`items.${index}.quantity`, event.target.value);

        setValue(`items.${index}.total`, total.toString()); // Convert to string

        // Recalculate Subtotal
        recalculateSubtotal();
    };

    const handleUnitPriceChange = (
        index: number,
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setValue(`items.${index}.unitPrice`, event.target.value);
        setValue(`items.${index}.total`, total.toString()); // Convert to string

        // Recalculate Subtotal
        recalculateSubtotal();
    };
    const handleQuantityChangeExcluded = (
        index: number,
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setValue(`itemsExcluded.${index}.quantity`, event.target.value);
        setValue(`itemsExcluded.${index}.total`, total.toString()); // Convert to string

        // Recalculate Subtotal
        recalculateSubtotal();
    };
    const handleUnitPriceChangeExcluded = (
        index: number,
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setValue(`itemsExcluded.${index}.unitPrice`, event.target.value);
        setValue(`itemsExcluded.${index}.total`, total.toString()); // Convert to string

        // Recalculate Subtotal
        recalculateSubtotal();
    };
    const handleCancelClick = () => {
        navigate(`/contacts/${id}/invoice`)
    };

    const actions: IHeaderListActions[] = [
        {
            type: 'button',
            text: 'Cancel',
            size: 'medium',
            onClick: handleCancelClick,
            variant: 'outlined',
            color: 'primary',
        },
        {
            type: 'button',
            text: 'Save',
            loading: loading,
            size: 'medium',
            onClick: handleSubmit((data) => handleData(data)),
            buttonType: 'submit',
            variant: 'outlined',
            color: 'primary',
        },
        {
            type: 'button',
            text: 'Save And Print',
            loading: loading,
            size: 'medium',
            onClick: handleSubmit((data) => handleData(data, true)),
            buttonType: 'submit',
            variant: 'outlined',
            color: 'primary',
        },
    ];

    const bankSource = {
        "url": "Bank/search",
        "page": 1,
        "pageSize": 100000,
        "filter": [

        ],
        "sort": [

        ]
    }
    const transFormData = (data: any) => {
        return data.map((item: any) => ({
            label: item.bankName,
            value: item.id
        }))
    }
    return (
        <Grid p={2}>
            <HeaderList title={invId ? "Invoice > Update New Invoice" : "Invoice > Create New Invoice"} type="card" actions={actions} isBackButton url={`/contact/edit/${id}`} />
            <form onSubmit={handleSubmit((data) => handleData(data))}>

                <Card
                    sx={{ borderRadius: "10px", padding: 3, position: "relative", mt: 2 }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography fontWeight={"bold"}> Invoice</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <WSTextField
                                label={"Customer Name *"}
                                rules={{ required: true }}
                                id={"customerName"}
                                name={"customerName"}
                                disabled
                                control={control}
                            />
                        </Grid>
                        <Grid item xs={10} sm={6}>
                            {/* <WSSelectField
                rules={{ required: false }}
                {...register("tax")}
                id="tax"
                control={control}
                label="Tax"
                name="tax"
                options={config.stageConfig.staticOptionData}
              /> */}
                            {/* <WSTextField
                                rules={{ required: false }}
                                {...register("tax")}
                                id="tax"
                                control={control}
                                label="Tax"
                                name="tax"
                            /> */}
                        </Grid>
                        <Grid item xs={10} sm={6}>
                            <WSTextField
                                label={"Address *"}
                                {...register("address")}
                                id="address"
                                name="address"
                                control={control}
                                rules={{ required: true }}
                            />
                        </Grid>
                        {/* <Grid item xs={10} sm={6}>
              <WSDateField
                id="date"
                name="date"
                label="Date *"
                control={control}
                rules={{ required: true }}
              />
            </Grid> */}
                        {/* <Grid item xs={10} sm={6}>
              <WSDateField
                id="expiredate"
                name="expiredate"
                label="Expiry Date"
                control={control}
                rules={{ required: true }}
              />
            </Grid> */}


                        <Grid item xs={12} sm={6}>
                            <WSSelectField
                                id="accountId"
                                label={"Select Bank"}
                                name="accountId"
                                control={control}
                                rules={{ required: "please select a bank" }}
                                source={bankSource}
                                transFormData={transFormData}
                            />
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <Divider />
                        </Grid>

                        {/* Section Title */}
                        <Grid item xs={12}>
                            <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>Items</Typography>

                        </Grid>

                        {/* Dynamic Item Fields */}

                        {itemFields.map((row: any, index: any) => (
                            <Grid
                                container
                                spacing={2}
                                key={row.id}
                                alignItems="center"
                                mt={1}
                                ml={1}
                            >
                                <Grid item xs={2}>
                                    <WSSelectField
                                        label="Select a Product"
                                        rules={{ required: true }}
                                        {...register(`items.${index}.productId`)}
                                        id={`selectProduct-${index}`}
                                        control={control}
                                        options={products.map((product: any) => ({
                                            label: product.name,
                                            value: product.id
                                        }))}
                                        inlineSearch
                                        onChange={(event) => handleProductChange(index, event)}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <WSTextField
                                        label="Unit"
                                        {...register(`items.${index}.unit`)}
                                        id={`unit-${index}`}
                                        control={control}
                                        disabled
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <WSTextField
                                        label="Unit Price"
                                        {...register(`items.${index}.unitPrice`, {
                                            onChange: (event) => handleUnitPriceChange(index, event)
                                        })}
                                        id={`unitPrice-${index}`}
                                        control={control}
                                        type={TextType.Currency}
                                        currency={CurrencyType.Rupee}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <WSTextField
                                        id={`quantity-${index}`}
                                        label="Quantity"
                                        {...register(`items.${index}.quantity`, {
                                            onChange: (event) => handleQuantityChange(index, event)
                                        })}
                                        control={control}
                                        type={TextType.Number}
                                    />
                                    <WSHiddenField control={control} name={`items.${index}.isIncluded`} />
                                </Grid>
                                <Grid item xs={2}>
                                    <WSSelectField
                                        label="Polish"
                                        rules={{ required: true }}
                                        {...register(`items.${index}.isPolish`)}
                                        id={`isPolish-${index}`}
                                        control={control}
                                        options={config.ploishConfig.staticOptionData}
                                        onChange={(event) => handleProductChange(index, event)}
                                    />
                                </Grid>
                                {/* Total Amount for each product*/}
                                <Grid item xs={1}>
                                    <Typography variant="body1" sx={{ fontSize: '0.875rem' }} fontWeight="bold">
                                        ₹
                                        {Number(watch(`items.${index}.unitPrice`) || 0) *
                                            Number(watch(`items.${index}.quantity`) || 0)}
                                    </Typography>
                                </Grid>

                                <Grid item display="flex" justifyContent="center">
                                    <WSIcons.DeleteIcon
                                        onClick={() => {
                                            itemRemove(index);
                                            recalculateSubtotal();
                                        }}
                                        sx={{ color: "red", cursor: 'pointer' }}
                                    />

                                </Grid>
                            </Grid>
                        ))}


                        <Grid item xs={12} sx={{ marginLeft: 1 }}>
                            <WSButton
                                id="addButton"
                                label="+ Add"
                                size="small"
                                onClick={() =>
                                    itemAppend({
                                        productId: "",
                                        quantity: "",
                                        unit: "",
                                        unitPrice: "",
                                        total: "",
                                        isIncluded: true,
                                        isPolish: "2"
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>Items Excluded</Typography>
                        </Grid>
                        {/* {itemExcludedFields.map((row, index) => (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="center"
                mt={1}
                ml={1}
              >
                <Grid item xs={12} sm={2}>
                  <WSSelectField isMobile={isMobile}
                    label="Select a Product"
                    rules={{ required: false }}
                    {...register(`itemsExcluded.${index}.productId`)}
                    id={`itemsExcluded-${index}`}
                    control={control}
                    options={products.map((product: any) => ({
                      label: product.name,
                      value: product.id
                    }))}
                    onChange={(event) => handleProductChangeExcluded(index, event)}
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Unit"
                    {...register(`itemsExcluded.${index}.unit`)}
                    id={`itemsExcluded-unit-${index}`}
                    control={control}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Unit Price"
                    {...register(`itemsExcluded.${index}.unitPrice`, {
                      onChange: (event) => handleUnitPriceChangeExcluded(index, event)
                    })}
                    id={`itemsExcluded-unitPrice-${index}`}
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <WSTextField
                    id={`itemsExcluded-quantity-${index}`}
                    label="Quantity"
                    {...register(`itemsExcluded.${index}.quantity`, {
                      onChange: (event) => handleQuantityChangeExcluded(index, event)
                    })}
                    control={control}
                    type={TextType.Number}
                  />
                  <WSHiddenField control={control} name={`itemsExcluded.${index}.isIncluded`} />
                </Grid>

          
                <Grid item xs={1} sm={1}>
                  <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                    ₹
                    {Number(watch(`itemsExcluded.${index}.unitPrice`) || 0) *
                      Number(watch(`itemsExcluded.${index}.quantity`) || 0)}
                  </Typography>
                </Grid>

                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => {
                      itemExcludedRemove(index);
                      recalculateSubtotal();
                    }}
                    sx={{ color: "red", cursor: 'pointer' }}
                  />
                </Grid>
              </Grid>
            ))} */}

                        {/* Add Item Button */}
                        {/* <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ ADD"
                size="small"
                sx={{ fontSize: '0.875rem' }}
                onClick={() =>
                  itemExcludedAppend({
                    productId: "",
                    quantity: "",
                    unit: "",
                    unitPrice: "",
                    total: "",
                    isIncluded: false,

                  })
                }
              />
            </Grid> */}
                        {/* Terms & Conditions */}
                        {/* <Grid item xs={12} sm={12}>
              <WSTextAreaField
                id="termsandcondition"
                label="Terms and Conditions"
                {...register("termsAndConditions")}
                control={control}
                rows={3}
              />
            </Grid>
            <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }} mt={2} ml={2}>
              Payment Terms
            </Typography>
            {paymentTerms.map((row, index) => (
              <Grid container spacing={2} key={row.id} alignItems="center" mt={1} ml={1}>
                <Grid item xs={6} sm={2}>
                  <WSTextField
                    label="Percentage"
                    {...register(`paymentTerms.${index}.percentage`, {
                      onChange: (event) => handlePercentageChange(index, event)
                    })}
                    id={`paymentTerms-percentage-${index}`}


                    control={control}
                    type={TextType.Number} // numeric input if needed
                  />
                </Grid>

                <Grid item xs={6} sm={6}>
                  <WSTextField
                    label="Description"
                    {...register(`paymentTerms.${index}.description`)}
                    id={`paymentTerms-description-${index}`}
                    control={control}
                  />
                </Grid>

                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => paymentRemove(index)}
                    sx={{ color: "red", cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
            ))} */}
                        {/* <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addExtraChargeButton"
                label="+ Add"
                size="small"
                sx={{ fontSize: "0.875rem" }}
                onClick={() =>
                  paymentAppend({
                    percentage: 0,
                    description: ""
                  })
                }
              />
            </Grid> */}
                        {/* Summary Section */}
                        <Grid
                            container
                            sx={{ backgroundColor: "whitesmoke", p: 2, mt: 2, ml: 2, borderRadius: 3 }}
                            spacing={2}
                        >
                            {/* Subtotal */}

                            <Grid item xs={8}>
                                <WSView title="Sub Total" style={{ fontSize: '0.875rem' }} />
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: "right" }}>
                                <WSView title={`₹ ${subtotal.toFixed(2)}`} />
                            </Grid>

                            {/* Discount */}
                            <Grid item xs={10}>
                                <WSView title="Discount" style={{ fontSize: '0.875rem' }} />
                            </Grid>
                            <Grid item xs={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <WSTextField
                                    id="discount"
                                    label="Discount"
                                    {...register("discount")}
                                    control={control}
                                    type={TextType.Number}
                                />
                            </Grid>

                            {/* Adjustments */}
                            <Grid item xs={10}>
                                <WSView title="Adjustments" style={{ fontSize: '0.875rem' }} />
                            </Grid>
                            <Grid item xs={2}>
                                <WSTextField
                                    id="adjustments"
                                    label="Adjustments"
                                    {...register("adjustments")}
                                    control={control}
                                    type={TextType.Number}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Divider />
                            </Grid>

                            {/* Total */}
                            <Grid item xs={8}>
                                <WSView title="Total ( ₹ )" style={{ fontSize: '0.875rem' }} />
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: "right" }}>
                                <WSView title={`₹ ${total.toFixed(2)}`} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>
            </form>
        </Grid>
    );
});
